import { render, staticRenderFns } from "./AIGCList.vue?vue&type=template&id=77c96f81&scoped=true"
import script from "./AIGCList.vue?vue&type=script&lang=js"
export * from "./AIGCList.vue?vue&type=script&lang=js"
import style0 from "./AIGCList.vue?vue&type=style&index=0&id=77c96f81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c96f81",
  null
  
)

export default component.exports